import {User,type UserData} from "@/types/users/user.ts";

export class UserSession {
    public id: number;
    public user_id: number;
    public seconds: number;
    public start_date: Date | null;
    public end_date: Date | null;
    public user: User | null;

    constructor(data: UserSessionData | undefined = undefined) {
        if (data === undefined) {
            this.id = 0;
            this.user_id = 0;
            this.seconds = 0;
            this.start_date = null;
            this.end_date = null;
            this.user = null;

        } else {
            this.id = data.id;
            this.user_id = data.user_id;
            this.seconds = data.seconds;
            this.start_date = null;
            if (data.start_date !== null) {
                this.start_date = new Date(data.start_date);
            }
            this.end_date = null;
            if (data.end_date !== null) {
                this.end_date = new Date(data.end_date);
            }
            if (data.user !== undefined && data.user !== null) {
                this.user = new User(data.user);
            } else {
                this.user = null;
            }

        }
    }
}

export type UserSessionData = {
    id: number;
    user_id: number;
    seconds: number;
    start_date: Date | null;
    end_date: Date | null;
    user: UserData | null | undefined;

}

